import { render, staticRenderFns } from "./BillPayment.vue?vue&type=template&id=4af35556"
import script from "./BillPayment.vue?vue&type=script&lang=js"
export * from "./BillPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports